import React from "react";
import { FormattedMessage } from "react-intl";
import useOverviewContext from "../../store/use-overview-context";

const FiltersControlReset = () => {
  const { currentFilters, resetFilters } = useOverviewContext();

  const isFiltered = !!currentFilters;

  const handleClick = (event) => {
    event.preventDefault();
    if (!isFiltered) return;
    resetFilters();
  };

  return (
    <button
      className="filters-control filters-control-reset"
      disabled={!isFiltered}
      onClick={handleClick}
    >
      <FormattedMessage id="controls.filter.reset" />
    </button>
  );
};

export default FiltersControlReset;
